// src/translations/pages/impressum/impressumUtils.js
import myInfo from './my_info.json';

/**
 * Injects personal data from my_info.json into impressum translations
 * @param {string} lang - Language code
 * @param {object} baseTranslation - Base translation object
 * @returns {object} - Translation object with injected personal data
 */
export const injectPersonalData = (lang, baseTranslation) => {
  return {
    ...baseTranslation,
    
    // Inject personal data
    providerData: {
      name: myInfo.personal.fullName,
      title: myInfo.personal.title[lang],
      // The register line is the official German designation and the same in
      // every language (IDD D-SAAS-143).
      register: myInfo.personal.register
    },
    
    // Inject address placeholders (can be easily updated in my_info.json)
    placeholders: {
      street: myInfo.address.street,
      postalCode: myInfo.address.postalCode,
      city: myInfo.address.city,
      country: myInfo.address.country[lang]
    },
    
    // Inject profession info
    professionValue: myInfo.personal.profession[lang],
    businessTypeValue: myInfo.personal.businessType[lang],
       
    // Inject legal framework
    legalFramework: myInfo.legal.framework[lang],
    
    // Contact email
    contactEmail: myInfo.contact.email
  };
};

/**
 * Helper function to get specific data by language
 * @param {string} path - Dot notation path (e.g., 'personal.title')
 * @param {string} lang - Language code
 * @returns {string} - Localized value
 */
export const getLocalizedData = (path, lang) => {
  const pathArray = path.split('.');
  let value = myInfo;
  
  for (const key of pathArray) {
    value = value[key];
    if (!value) return null;
  }
  
  // If value is an object with language keys, return the specific language
  if (typeof value === 'object' && value[lang]) {
    return value[lang];
  }
  
  // If it's a simple value, return as is
  return value;
};

/**
 * Check if personal data is complete (no placeholder brackets)
 * @returns {boolean} - True if data appears complete
 */
export const isPersonalDataComplete = () => {
  const hasPlaceholders = (obj) => {
    const str = JSON.stringify(obj);
    return str.includes('[') && str.includes(']');
  };
  
  return !hasPlaceholders(myInfo.address) && !hasPlaceholders(myInfo.personal);
};
